const WARNING_THRESHOLD_PERCENT = 0.0;
const ERROR_THRESHOLD_PERCENT = 10.0;

export const identityFormatLabel = (label: string): string => label;

export const formatCell = (
  count: number,
  total: number,
  formatPercent: (value?: number | null) => string
): string => {
  if (total === 0) return `${formatPercent(0)}% (0)`;
  return `${formatPercent((count / total) * 100)}% (${count})`;
};

export const getCellColor = ({
  isErrorRate,
  percent,
  background,
}: {
  isErrorRate: boolean;
  percent: number;
  background: "light" | "dark";
}): string => {
  if (!isErrorRate && percent >= 100.0 - WARNING_THRESHOLD_PERCENT) {
    return "success.main";
  } else if (!isErrorRate && percent >= 100.0 - ERROR_THRESHOLD_PERCENT) {
    return "warning.main";
  } else if (!isErrorRate) {
    return "error.main";
  } else if (percent > ERROR_THRESHOLD_PERCENT) {
    return "error.main";
  } else if (percent > WARNING_THRESHOLD_PERCENT) {
    return "warning.main";
  } else {
    return background === "dark" ? "common.white" : "text.primary";
  }
};
